const ACTIVITY_INTERVAL = 60000;
const ACTIVITY_EVENTS = ['pointerdown', 'keydown', 'scroll'];

export default class AgentActivityTracker {
  constructor({ send, isImpersonating }) {
    this.send = send;
    this.isImpersonating = isImpersonating;
    this.enabled = false;
    this.entryPending = true;
    this.lastSentAt = -Infinity;
    ACTIVITY_EVENTS.forEach(event => {
      document.addEventListener(event, this.onActivity, {
        capture: true,
        passive: true,
      });
    });
    document.addEventListener('visibilitychange', this.onActivity);
    window.addEventListener('focus', this.onActivity);
  }

  setEnabled(enabled) {
    this.enabled = enabled;
    if (!enabled) this.entryPending = false;
    if (enabled && this.entryPending) this.recordActivity();
  }

  onActivity = event => {
    if (!event.isTrusted) return;
    this.recordActivity();
  };

  recordActivity() {
    if (
      !this.enabled ||
      this.isImpersonating() ||
      document.hidden ||
      !document.hasFocus()
    ) {
      return;
    }
    const now = performance.now();
    if (now - this.lastSentAt < ACTIVITY_INTERVAL) return;

    if (this.send({ reset_availability: this.entryPending })) {
      this.entryPending = false;
      this.lastSentAt = now;
    }
  }

  disconnect() {
    ACTIVITY_EVENTS.forEach(event => {
      document.removeEventListener(event, this.onActivity, true);
    });
    document.removeEventListener('visibilitychange', this.onActivity);
    window.removeEventListener('focus', this.onActivity);
  }
}
